import { useState, useEffect } from "react";
import styles from "./styles.module.css";

const LoUltimoVertical = (props) => {
  const { title } = props;
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const dateToHourMinutes = (date) => {
    const hour = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    return `${hour}:${minutes} `;
  };

  return (
    <>
      {props.content && props.content.length > 0 && (
        <div className={styles["loultimo-parent"]}>
          <p className={styles["loultimo-title"]}>
            <span className={styles["loultimo-title-icon"]}><svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 7V12L13.5 14.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg></span>
            {title ? title : "LO ÚLTIMO"}
          </p>

          <div className={styles["loultimo-container"]}>
            {props.content.map((element, id) => {
              const { url, title, publishedDate } = element;

              const noteDate = new Date(publishedDate);

              return (
                <div
                  key={id}
                  className={styles["loultimo-container-text"]}
                >
                  <a href={url}>
                    <div className={styles["loultimo-hour"]}>
                      {isClient && dateToHourMinutes(noteDate)}
                    </div>
                    {title}
                  </a>
                </div>
              );
            })}
          </div>
          <a
            href="https://www.ellitoral.com/titulos"
            className={styles["ver-todas-un"]}
          >
            Ver todas las noticias

            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 12H19M19 12L13 6M19 12L13 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </a>
        </div>
      )}
    </>
  );
};

export default LoUltimoVertical;